import { schema } from 'normalizr';

import { SCHEMA_TYPE_USER_SETTINGS } from '../constants/schemaTypes';

import userSchema from './user';
import orgSchema from './org';

const userSettingsSchema = new schema.Entity(SCHEMA_TYPE_USER_SETTINGS, {
  owner: userSchema,
  org: orgSchema,
});

export default userSettingsSchema;
